<template>
<div style="position: relative">

  <div class="user--content">
    <div class="user--content__photo" @click="showMenu()">
      <img class="icon_photo user" src="@/assets/img/personagens/2.svg" alt="Perfil">
      <img class="icon_config config" src="@/assets/img/menu/settings.svg" alt="Configuration">
    </div>
    <div class="user--content__name">
      {{user.name}}
    </div>
    <!-- <div class="user--content__config" @click="$store.dispatch('auth/logout')"> -->
    <div class="user--content__config" @click="showMenu()">
      <img src="@/assets/img/menu/config.svg" class="config" alt="Minds">
    </div>
  </div>

</div>
</template>

<script>
import appBus from '@/plugins/appBus'

export default {
  name: 'userContent',
  data () {
    return {
      student: {
        image: 'user',
        imageType: 'png'
      }
    }
  },
  props: {
    data: {
      type: Object,
      default: { name: 'Default' }
    }
  },
  computed: {
    user () {
      return {...this.student, ...this.data }
    }
  },
  methods: {
    showMenu () {
      appBus.$emit('showMenu', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.user--content {
    transition: 0.3s;
    width: 250px;
    max-width: 100%;
    height: 35px;
    background: #fff;
    border-radius: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user--content__photo {
        transition: 0.3s;
        width: 50px;
        min-width: 50px;
        height: 50px;
        background: #ddd;
        border: 2px solid #fff;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
        .user {
            width: 100%;
        }
        .icon_config{
          display: none;
        }
    }
    .user--content__name {
        transition: 0.3s;
        font-size: 14px;
        color: #515151;
        font-weight: 300;
        flex-grow: 1;
        text-align: center;
    }
    .user--content__config {
        cursor: pointer;
        transition: 0.3s;
        width: 50px;
        height: 35px;
        background: #979797;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          .config {
            transform: rotate(90deg);
          }
        }
        .config {
          transition: transform .2s;
          width: 25px;
          max-width: 90%;
        }
    }
}
@media screen and (max-width: 800px) {
    .user--content {
        margin-left: 5px;
        width: 40px;
        .user--content__config,
        .user--content__name {
            display: none;
        }
        .user--content__photo {
            background: #73001c;
            width: 40px;
            min-width: 40px;
            max-width: 40px;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            border: none;
            .icon_config{
                display: inline;
            }
            .icon_photo{
              display: none;
            }
            .config {
              width: 25px;
              margin: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/userContent.vue